import React from 'react';
import { Alert } from 'antd';

const NotFoundPage = () => {
    return (       
        <Alert
            message="Not Found"
            description="The page you are looking for cannot be found."
            type="error" 
            style={ {
                margin: '40px'
            } }
        /> 
    );
};

export default NotFoundPage;
